/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
import AdminNavbar from "components/navbars/AdminNavbar.js";

const user = localStorage.getItem("cargo") || "";
const normalizedUser = user.trim().toUpperCase();

const isRh = normalizedUser === "ADMIN" || normalizedUser === "RH";
const isSac = normalizedUser === "ADMIN" || normalizedUser === "SAC" || normalizedUser === "ENTREGADOR";
const isFuncionario = normalizedUser === "ADMIN" || normalizedUser === "FUNCIONARIO";
const isGerente = normalizedUser === "ADMIN" || normalizedUser === "GERENTE";
const isEntregador = normalizedUser === "ENTREGADOR";

export default function Sidebar() {
  const [collapseShow, setCollapseShow] = React.useState("hidden");
  return (
    <>
      <nav className="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6">
        <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">

          {/* Toggler */}
          <button
            className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
            type="button"
            onClick={() => setCollapseShow("bg-white m-2 py-3 px-6")}
          >
            <i className="fas fa-bars"></i>
          </button>

          <div className="flex items-center space-x-4">
            <img
              src={require("../../assets/img/logoa.png")}
              width="40"
              height="40"
              alt="Logo"
            />
            <Link
              className="text-blueGray-600 text-sm uppercase font-bold"
              to="/admin"
            >
              RTA CONTROLLER
            </Link>
          </div>



          {/* Collapse */}
          <div className={"md:flex md:flex-col  md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " + collapseShow}>
            {/* Collapse header */}
            <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
              <div className="flex flex-wrap">
                <div className="w-6/12">
                  <Link
                    className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                    to="/"
                  >
                    RTA CONTROLLER
                  </Link>
                </div>
                <div className="w-6/12 flex justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={() => setCollapseShow("hidden")}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="block lg:hidden md:hidden">
              <AdminNavbar />
            </div>

            {/* Heading */}
            <h6 className={"md:min-w-full text-xs uppercase font-bold block pt-1 pb-4 no-underline " +
              (window.location.href.indexOf("/admin/calendario") !== -1 ||
                window.location.href.indexOf("/admin/logistica/base") !== -1 ||
                window.location.href.indexOf("/admin/logistica/rua") !== -1 ||
                window.location.href.indexOf("/admin/logistica/distribuir") !== -1 ||
                window.location.href.indexOf("/admin/logistica/recebidos") !== -1 ||
                window.location.href.indexOf("/admin/logistica/atribuir") !== -1 ||
                window.location.href.indexOf("/admin/logistica/recusados") !== -1

                ? "text-lightBlue-600"
                : "text-blueGray-700 ")}>
              LOGÍSTICA
            </h6>

            {/* Navigation */}

            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/calendario") !== -1
                      ? "text-lightBlue-400 hover:text-lightBlue-500"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/calendario"
                >
                  <i
                    className={
                      "fas fa-calendar mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/calendario") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  calendário
                </Link>
              </li>
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/logistica/base") !== -1
                      ? "text-lightBlue-400 hover:text-lightBlue-500"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/logistica/base"
                >
                  <i
                    className={
                      "fas fa-home mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/logistica/base") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  NA BASE
                </Link>
              </li>
              {isFuncionario && (

                <li className="items-center">
                  <Link
                    className={
                      "text-xs uppercase py-3 font-bold block " +
                      ((window.location.href.indexOf("/admin/logistica/distribuir") !== -1 || window.location.href.indexOf("/admin/logistica/atribuir") !== -1)
                        ? "text-lightBlue-400 hover:text-lightBlue-500"
                        : "text-blueGray-700 hover:text-blueGray-500")
                    }
                    to="/admin/logistica/distribuir"
                  >
                    <i
                      className={
                        "fas fa-paper-plane mr-2 text-sm " +
                        ((window.location.href.indexOf("/admin/logistica/distribuir") !== -1 || window.location.href.indexOf("/admin/logistica/atribuir") !== -1)
                          ? "opacity-75"
                          : "text-blueGray-300")
                      }
                    ></i>{" "}
                    DISTRIBUIR
                  </Link>
                </li>
              )}
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/logistica/rua") !== -1
                      ? "text-lightBlue-400 hover:text-lightBlue-500"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/logistica/rua"
                >
                  <i
                    className={
                      "fas fa-map-marked mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/logistica/rua") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  NA RUA
                </Link>
              </li>
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/logistica/recebidos") !== -1
                      ? "text-lightBlue-400 hover:text-lightBlue-500"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/logistica/recebidos"
                >
                  <i
                    className={
                      "fas fa-check-circle mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/logistica/recebidos") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  RECEBIDOS
                </Link>
              </li>
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/logistica/recusados") !== -1
                      ? "text-lightBlue-400 hover:text-lightBlue-500"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/logistica/recusados"
                >
                  <i
                    className={
                      "fas fa-exclamation-triangle mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/logistica/recusados") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  RECUSADOS
                </Link>
              </li>
            </ul>

            {isGerente && (
              <>
                <hr className="my-4 md:min-w-full" />
                <h6 className={"md:min-w-full text-xs uppercase font-bold block pt-1 pb-4 no-underline " +
                  (window.location.href.indexOf("/admin/gestao/registro") !== -1 ||
                    window.location.href.indexOf("/admin/gestao/funcionarios") !== -1 ||
                  
                    window.location.href.indexOf("/admin/gestao/liberar") !== -1 ||
                    window.location.href.indexOf("/admin/gestao/inativo") !== -1

                    ? "text-lightBlue-600"
                    : "text-blueGray-700 ")}>
                  GESTÃO
                </h6>
                <ul className="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">
                  <li className="items-center">
                    <Link
                      className={
                        "text-xs uppercase py-3 font-bold block " +
                        (window.location.href.indexOf("/admin/gestao/registro") !== -1
                          ? "text-lightBlue-400 hover:text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500")
                      }
                      to="/admin/gestao/registro"
                    >
                      <i
                        className={
                          "fa fa-handshake mr-2 text-sm " +
                          (window.location.href.indexOf("/admin/gestao/registro") !== -1
                            ? "opacity-75"
                            : "text-blueGray-300")
                        }
                      ></i>{" "}
                      Cadastros
                    </Link>
                  </li>
                  <li className="items-center">
                    <Link
                      className={
                        "text-xs uppercase py-3 font-bold block " +
                        (window.location.href.indexOf("/admin/gestao/funcionarios") !== -1
                          ? "text-lightBlue-400 hover:text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500")
                      }
                      to="/admin/gestao/funcionarios"
                    >
                      <i
                        className={
                          "fa fa-sitemap mr-2 text-sm " +
                          (window.location.href.indexOf("/admin/gestao/funcionarios") !== -1
                            ? "opacity-75"
                            : "text-blueGray-300")
                        }
                      ></i>{" "}
                      Funcionários
                    </Link>
                  </li>


                  
                  <li className="items-center">
                    <Link
                      className={
                        "text-xs uppercase py-3 font-bold block " +
                        (window.location.href.indexOf("/admin/gestao/liberar") !== -1
                          ? "text-lightBlue-400 hover:text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500")
                      }
                      to="/admin/gestao/liberar"
                    >
                      <i
                        className={
                          "fa fa-search-plus mr-2 text-sm " +
                          (window.location.href.indexOf("/admin/gestao/liberar") !== -1
                            ? "opacity-75"
                            : "text-blueGray-300")
                        }
                      ></i>{" "}
                      Liberar
                    </Link>
                  </li>
                  <li className="items-center">
                    <Link
                      className={
                        "text-xs uppercase py-3 font-bold block " +
                        (window.location.href.indexOf("/admin/gestao/inativo") !== -1
                          ? "text-lightBlue-400 hover:text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500")
                      }
                      to="/admin/gestao/inativo"
                    >
                      <i
                        className={
                          "fa fa-archive mr-2 text-sm " +
                          (window.location.href.indexOf("/admin/gestao/inativo") !== -1
                            ? "opacity-75"
                            : "text-blueGray-300")
                        }
                      ></i>{" "}
                      Inativo
                    </Link>
                  </li>

                </ul>
              </>
            )}
            <hr className="my-4 md:min-w-full" />
            <h6 className={"md:min-w-full text-xs uppercase font-bold block pt-1 pb-4 no-underline " +
              (window.location.href.indexOf("/admin/devolucao/tratativa") !== -1 ||
                window.location.href.indexOf("/admin/devolucao/transito") !== -1 ||
                window.location.href.indexOf("/admin/devolucao/atribuir") !== -1 ||
                window.location.href.indexOf("/admin/devolucao/distribuir") !== -1 ||
                window.location.href.indexOf("/admin/devolucao/pacote") !== -1

                ? "text-lightBlue-600"
                : "text-blueGray-700 ")}>
              Devolução
            </h6>

            <ul className="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">
              
                <>
                  <li className="items-center">
                    <Link
                      className={
                        "text-xs uppercase py-3 font-bold block " +
                        (window.location.href.indexOf("/admin/devolucao/tratativa") !== -1
                          ? "text-lightBlue-400 hover:text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500")
                      }
                      to="/admin/devolucao/tratativa"
                    >
                      <i
                        className={
                          "fa fa-clone mr-2 text-sm " +
                          (window.location.href.indexOf("/admin/devolucao/tratativa") !== -1
                            ? "opacity-75"
                            : "text-blueGray-300")
                        }
                      ></i>{" "}
                      Tratativa
                    </Link>
                  </li>
                </>
              
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/devolucao/transito") !== -1
                      ? "text-lightBlue-400 hover:text-lightBlue-500"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/devolucao/transito"
                >
                  <i
                    className={
                      "fa fa-random mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/devolucao/transito") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Transito
                </Link>
              </li>
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/devolucao/pacote") !== -1
                      ? "text-lightBlue-400 hover:text-lightBlue-500"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/devolucao/pacote"
                >
                  <i
                    className={
                      "fa fa-barcode mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/devolucao/pacote") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Pacotes
                </Link>
              </li>
              
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    ((window.location.href.indexOf("/admin/devolucao/distribuir") !== -1 || window.location.href.indexOf("/admin/devolucao/atribuir") !== -1)
                      ? "text-lightBlue-400 hover:text-lightBlue-500"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/devolucao/distribuir"
                >
                  <i
                    className={
                      "fa fa-envelope-open mr-2 text-sm " +
                      ((window.location.href.indexOf("/admin/devolucao/distribuir") !== -1 || window.location.href.indexOf("/admin/devolucao/atribuir") !== -1)
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  COletar
                </Link>
              </li>

            </ul>

            {isSac && (
              <>
                <hr className="my-4 md:min-w-full" />
                <h6 className={"md:min-w-full text-xs uppercase font-bold block pt-1 pb-4 no-underline " +
                  (window.location.href.indexOf("/admin/administrativo/ocorrencia") !== -1

                    ? "text-lightBlue-600"
                    : "text-blueGray-700 ")}>
                  ADMINISTRATIVO
                </h6>
                <ul className="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">

                  <li className="items-center">
                    <Link
                      className={
                        "text-xs uppercase py-3 font-bold block " +
                        (window.location.href.indexOf("/admin/administrativo/ocorrencia") !== -1
                          ? "text-lightBlue-400 hover:text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500")
                      }
                      to="/admin/administrativo/ocorrencia"
                    >
                      <i
                        className={
                          "fa fa-flag mr-2 text-sm " +
                          (window.location.href.indexOf("/admin/administrativo/ocorrencia") !== -1
                            ? "opacity-75"
                            : "text-blueGray-300")
                        }
                      ></i>{" "}
                      Ocorrência
                    </Link>
                  </li>


                  <li className="items-center">
                    <Link
                      className={
                        "text-xs uppercase py-3 font-bold block " +
                        (window.location.href.indexOf("/admin/administrativo/contagem") !== -1
                          ? "text-lightBlue-400 hover:text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500")
                      }
                      to="/admin/administrativo/contagem"
                    >
                      <i
                        className={
                          "fa fa-tablet   mr-2 text-sm " +
                          (window.location.href.indexOf("/admin/administrativo/contagem") !== -1
                            ? "opacity-75"
                            : "text-blueGray-300")
                        }
                      ></i>{" "}
                      Contagem
                    </Link>
                  </li>
                  <li className="items-center">
                    <Link
                      className={
                        "text-xs uppercase py-3 font-bold block " +
                        (window.location.href.indexOf("/admin/administrativo/cobranca") !== -1
                          ? "text-lightBlue-400 hover:text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500")
                      }
                      to="/admin/administrativo/cobranca"
                    >
                      <i
                        className={
                          "fa fa-comments   mr-2 text-sm " +
                          (window.location.href.indexOf("/admin/administrativo/cobranca") !== -1
                            ? "opacity-75"
                            : "text-blueGray-300")
                        }
                      ></i>{" "}
                      Cobrança
                    </Link>
                  </li>

                </ul>
              </>
            )}
            {isRh && (
              <>
                <hr className="my-4 md:min-w-full" />
                <h6 className={"md:min-w-full text-xs uppercase font-bold block pt-1 pb-4 no-underline " +
                  (window.location.href.indexOf("/admin/financeiro/pontos") !== -1 ||
                    window.location.href.indexOf("/admin/financeiro/liberar") !== -1 ||
                    window.location.href.indexOf("/admin/financeiro/contabilidade") !== -1

                    ? "text-lightBlue-600"
                    : "text-blueGray-700 ")}>
                  Financeiro
                </h6>
                <ul className="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">
                  <li className="items-center">
                    <Link
                      className={
                        "text-xs uppercase py-3 font-bold block " +
                        (window.location.href.indexOf("/admin/financeiro/pontos") !== -1
                          ? "text-lightBlue-400 hover:text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500")
                      }
                      to="/admin/financeiro/pontos"
                    >
                      <i
                        className={
                          "fa fa-calendar  mr-2 text-sm " +
                          (window.location.href.indexOf("/admin/financeiro/pontos") !== -1
                            ? "opacity-75"
                            : "text-blueGray-300")
                        }
                      ></i>{" "}
                      Pontos
                    </Link>
                  </li>
                  <li className="items-center">
                    <Link
                      className={
                        "text-xs uppercase py-3 font-bold block " +
                        (window.location.href.indexOf("/admin/financeiro/liberar") !== -1
                          ? "text-lightBlue-400 hover:text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500")
                      }
                      to="/admin/financeiro/liberar"
                    >
                      <i
                        className={
                          "fa fa-clock  mr-2 text-sm " +
                          (window.location.href.indexOf("/admin/financeiro/liberar") !== -1
                            ? "opacity-75"
                            : "text-blueGray-300")
                        }
                      ></i>{" "}
                      Gerar
                    </Link>
                  </li>
                  <li className="items-center">
                    <Link
                      className={
                        "text-xs uppercase py-3 font-bold block " +
                        (window.location.href.indexOf("/admin/financeiro/contabilidade") !== -1
                          ? "text-lightBlue-400 hover:text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500")
                      }
                      to="/admin/financeiro/contabilidade"
                    >
                      <i
                        className={
                          "fa fa-server  mr-2 text-sm " +
                          (window.location.href.indexOf("/admin/financeiro/contabilidade") !== -1
                            ? "opacity-75"
                            : "text-blueGray-300")
                        }
                      ></i>{" "}
                      Contabilidade
                    </Link>
                  </li>
                  <li className="items-center">
                    <Link
                      className={
                        "text-xs uppercase py-3 font-bold block " +
                        (window.location.href.indexOf("/admin/financeiro/cidades") !== -1
                          ? "text-lightBlue-400 hover:text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500")
                      }
                      to="/admin/financeiro/cidades"
                    >
                      <i
                        className={
                          "fa fa-university mr-2 text-sm " +
                          (window.location.href.indexOf("/admin/financeiro/cidades") !== -1
                            ? "opacity-75"
                            : "text-blueGray-300")
                        }
                      ></i>{" "}
                      Prazos
                    </Link>
                  </li>

                </ul>
              </>
            )}
            <hr className="my-4 md:min-w-full" />
            <h6 className="md:min-w-full text-blueGray-500 text-xs uppercase font-bold block pt-1 pb-4 no-underline">
              CONTA
            </h6>
            <ul className="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/auth") !== -1
                      ? "text-lightBlue-400 hover:text-lightBlue-500"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/auth"
                  onClick={() => {
                    localStorage.clear();
                    window.location.href = "/auth";
                  }}
                >
                  <i
                    className={
                      "fa fa-window-close mr-2 text-sm " +
                      (window.location.href.indexOf("/auth") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  LOGOUT
                </Link>
              </li>
            </ul>


          </div>
        </div>
      </nav>
    </>
  );
}
